import { Show } from 'shared';

import { ParticipantsSessionDateTimeMenu } from 'features/participants/components/Table/DateCellContent/ParticipantsSessionDateTimeMenu';
import { ParticipantsScheduleSessionDateTimeButton } from 'features/participants/components/Table/DateCellContent/SelectSessionDateTimeButton';
import {
  CoachingMode,
  ParticipantsTableUserInfo,
} from 'features/participants/config/types';
import { SessionAttendanceStatusType } from 'features/sessions/config/types';
import { IDraftSprint, ISprint } from 'features/sprint/config/types';

type SessionDateCellContentProps = {
  userInfo: ParticipantsTableUserInfo;
  startAt: string;
  sessionId: string;
  attendance: SessionAttendanceStatusType;
  latestSprint?: ISprint | IDraftSprint;
  coachingMode: CoachingMode;
};

export const SessionDateCellContent = ({
  userInfo,
  startAt,
  sessionId,
  attendance,
  latestSprint,
  coachingMode,
}: SessionDateCellContentProps) => {
  const recentSprints = latestSprint ? [latestSprint] : [];
  const { email, userId } = userInfo;

  return (
    <Show
      when={startAt}
      fallback={
        <ParticipantsScheduleSessionDateTimeButton
          userEmail={email}
          userId={userId}
          recentSprints={recentSprints}
          coachingMode={coachingMode}
        />
      }
    >
      <ParticipantsSessionDateTimeMenu
        userEmail={email}
        startAt={startAt}
        sessionId={sessionId}
        attendance={attendance}
        coachingMode={coachingMode}
      />
    </Show>
  );
};
